import React, { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Card, Flex, message, Skeleton, Typography, theme } from 'antd';

import { Semester } from './components/Semester';
import { CustomDatePicker } from '../../../../components/CustomDatePicker';

import apis from '../../../../services/Apis';

import { table } from './struct';
import { TableDescription } from '../../../../components/TableDescription';
import { SecureGet } from '../../../../services/axiosCall';

import { formRules } from '../../../../const/formRules';
import { convertPlanningToRequestData, convertToRequestData, convertToTableData } from './utils/dataConverter';
import useEvaluationSemester from '../../../../hooks/useEvaluationSemester';


const { Title } = Typography;

const Table32 = ({ currentApas, tableNo, title, menu }) => {
  const apa = currentApas.find((item) => item.form_no === tableNo) || {};
  const [messageApi, contextHolder] = message.useMessage();

  const { token } = theme.useToken();

  const user = useSelector((state) => state.user);
  const { userDetails } = user;

  const [loading, setLoading] = useState(false);
  const handleLoading = (loading) => setLoading(loading);

  const [apaShortDes, setApaShortDes] = useState(null);
  const {
    form_no: formNo,
    form_name: formName,
    max_point: maxPoints
  } = apaShortDes || {};
  const handleApaShortDes = (des) => setApaShortDes(des);


  const [apaRules, setApaRules] = useState(null);
  const handleApaRules = (rules) => setApaRules(rules);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear() - 1;
  const [selectedYear, setSelectedYear] = useState(Number(currentYear));
  const handleSelectedYear = (_, yearString) =>
    setSelectedYear(Number(yearString));


  const fetchApaShortDes = (id) => {
    handleApaShortDes(null);
    handleLoading(true);

    SecureGet({ url: `${apis.FORM_LIST}/${id}` })
      .then((response) => {
        handleApaShortDes(response.data);
        handleLoading(false);
      })
      .catch(() => {
        handleLoading(false);
      });
  };


  const {
    planing,
    fetchLoading,
    updatePlaning,
    handlePlaning,
    evaluatePlaning,
    cumulativeApaPoints,
    semesterLoading,
    semesterComments
  } = useEvaluationSemester({
    url: apis.EVALUATION_SEMESTER,
    formId: apa.id,
    userDetails: userDetails.user_id,
    selectedYear: selectedYear,
    messageApi: messageApi,
    convertToTableData: convertToTableData,
    convertToRequestData: convertToRequestData,
    convertPlanningToRequestData: convertPlanningToRequestData
  });


  //Only temp semester name will be update
  const setSemesterName = (semesterName, id) => {
    const index = planing.findIndex((item) => item.semester === semesterName);
    if (index < 0) {
      handlePlaning(
        planing.map((item) =>
          item.tempSemester === id
            ? {
              ...item,
              tempSemester: null,
              semester: semesterName,
              courses: []
            }
            : { ...item }
        )
      );
    } else {
      messageApi.error('Can not create duplicate semester');
    }
  };

  const updateSemester = (semesterName, courses) => {
    handlePlaning((prev) =>
      prev.map((item) =>
        item.semester === semesterName
          ? {
            ...item,
            courses
          }
          : { ...item }
      )
    );
  };


  useEffect(() => {
    if (menu?.currentApaId) fetchApaShortDes(menu?.currentApaId);
  }, [menu]);

  useEffect(() => {
    if (apaShortDes) {
      const _formRules = formRules.find((item) => formNo === item.id);
      const { rules } = _formRules || {};
      handleApaRules(rules);
    }
  }, [apaShortDes]);


  return (
    <div>
      <div
        style={{
          position: 'sticky',
          top: -16,
          zIndex: 1000,
          backgroundColor: token.colorBgLayout,
          paddingBottom: '8px',
        }}
      >
        {
          apaShortDes && !loading &&
          <TableDescription
            formNo={menu?.currentMenuId}
            formName={formName}
            maxPoints={maxPoints}
            rules={apaRules}
            cumulativeApaPoints={cumulativeApaPoints}
            isEvaluation={true}
          />
        }
      </div>
      <br />
      <Card {...table.wrapper}>
        {contextHolder}
        <Title level={5}>{title ? title : ''}</Title>
        <br />
        <Flex {...table.header}>
          <CustomDatePicker
            selectedYear={selectedYear}
            handleSelectedYear={handleSelectedYear}
            isEvaluation={true}
          />
        </Flex>
        <br />

        {planing && !fetchLoading ? (
          planing?.length > 0 && planing?.map((semester) => (
            <Fragment key={semester.semester}>
              <Semester
                semesterDetail={semester}
                setSemesterName={setSemesterName}
                updateSemester={updateSemester}
                loading={fetchLoading}
                evaluatePlaning={evaluatePlaning}
                updatePlaning={updatePlaning}
                semesterLoading={semesterLoading}
                status={semester.status}
                semesterComments={semesterComments}
              />
              <br />
            </Fragment>
          ))
        ) : (
          <Skeleton loading={fetchLoading} active />
        )}

      </Card>
    </div>
  );
};

export default Table32;